import axios from 'axios';

const RESOURCE_NAME = '/trackers';

export default {

    getList(type = '') {
        return axios.get(`${RESOURCE_NAME}/get-list?type=${type}`)
    },

    getListForStartupAdd() {
        return axios.get(`${RESOURCE_NAME}/get-list-for-startup-add`)
    },

    getInfo(id) {
        return axios.get(`${RESOURCE_NAME}/get-info?id=${id}`)
    },

    getNotes(id) {
        return axios.get(`${RESOURCE_NAME}/get-notes?id=${id}`)
    },

    addNote(id, data) {
        return axios.post(`${RESOURCE_NAME}/add-note?id=${id}`, data)
    },

    getTrackerEdit(id) {
        return axios.get(`${RESOURCE_NAME}/get-edit?id=${id}`)
    },

    update(id, data) {
        return axios.post(`${RESOURCE_NAME}/update-tracker?id=${id}`, data)
    },

    delete(id) {
        return axios.post(`${RESOURCE_NAME}/delete-tracker?id=${id}`)
    },

    getPipelineStages(id) {
        return axios.get(`${RESOURCE_NAME}/pipeline-stages?id=${id}`)
    },

    getTrackersIndex(filterType, search) {
        return axios.get(`${RESOURCE_NAME}/get-trackers-index?filter_type=${filterType}&search=${search}`)
    },

    getTrackersNumber() {
        return axios.get(`${RESOURCE_NAME}/get-trackers-number`)
    },

    save(id, data) {
        return axios.post(`${RESOURCE_NAME}/save?id=${id}`, data)
    },

    duplicate(id, data) {
        return axios.post(`${RESOURCE_NAME}/duplicate?id=${id}`, data)
    },

    // Folders
    getFoldersIndex(filterType, search) {
        return axios.get(`${RESOURCE_NAME}/get-folders-index?filter_type=${filterType}&search=${search}`)
    },

    getFoldersNumber() {
        return axios.get(`${RESOURCE_NAME}/get-folders-number`)
    },

    getFoldersList() {
        return axios.get(`${RESOURCE_NAME}/get-folders-list`)
    },

    getFolderInfo(id) {
        return axios.get(`${RESOURCE_NAME}/get-folder-info?folder_id=${id}`)
    },

    getFolderEdit(id) {
        return axios.get(`${RESOURCE_NAME}/get-folder-edit?folder_id=${id}`)
    },

    saveFolder(id, data) {
        return axios.post(`${RESOURCE_NAME}/save-folder?folder_id=${id}`, data)
    },

    archiveFolder(id) {
        return axios.post(`${RESOURCE_NAME}/archive-folder?folder_id=${id}`)
    },

    unarchiveFolder(id) {
        return axios.post(`${RESOURCE_NAME}/unarchive-folder?folder_id=${id}`)
    },

    deleteFolder(id) {
        return axios.post(`${RESOURCE_NAME}/delete-folder?folder_id=${id}`)
    },

    getFolderTrackersIndex(id) {
        return axios.get(`${RESOURCE_NAME}/get-trackers-index?folder_id=${id}`)
    },

    getPipelinesList() {
        return axios.get(`${RESOURCE_NAME}/get-pipelines-list`)
    },

    getStartupsListToAdd(id, search) {
        return axios.post(`${RESOURCE_NAME}/get-startups-list-to-add?id=${id}`, {search: search})
    },

    getTemplates() {
        return axios.get(`${RESOURCE_NAME}/get-templates`)
    },

    getTemplatesIndex(data) {
        return axios.post(`${RESOURCE_NAME}/get-templates-index`, data)
    },

    getTemplateEdit(id) {
        return axios.get(`${RESOURCE_NAME}/get-template-edit?template_id=${id}`)
    },

    saveTemplate(id, data) {
        return axios.post(`${RESOURCE_NAME}/save-template?template_id=${id}`, data)
    },

    deleteTemplate(id) {
        return axios.post(`${RESOURCE_NAME}/delete-template?template_id=${id}`)
    },

    saveSubmitterFiles(trackerId, fieldId, data) {
        return axios.post(`${RESOURCE_NAME}/save-submitter-files?id=${trackerId}&field_id=${fieldId}`, data,
            {
                headers: {
                    'Content-Type': 'multipart/form-data'
                }
            })
    },

    getRoles() {
        return axios.get(`${RESOURCE_NAME}/get-roles`)
    },

    addToFolder(folderId, trackerIds) {
        return axios.post(`${RESOURCE_NAME}/add-to-folder?folder_id=${folderId}`, {tracker_ids: trackerIds})
    },

    setFavorite(id, favorite) {
        return axios.post(`${RESOURCE_NAME}/set-favorite?id=${id}`, {favorite: favorite})
    },

    getStages(ids) {
        return axios.post(`${RESOURCE_NAME}/get-stages`, {ids: ids})
    },

    shareWithEcosystems(id, ecosystemIds) {
        return axios.post(`${RESOURCE_NAME}/share-with-ecosystems?id=${id}`, {ecosystem_ids: ecosystemIds})
    },

    getSharedEcosystems(id) {
        return axios.post(`${RESOURCE_NAME}/get-shared-ecosystems?id=${id}`)
    },

    revokeShareWithEcosystems(id, ecosystemId) {
        return axios.post(`${RESOURCE_NAME}/revoke-share-with-ecosystems?id=${id}`, {ecosystem_id: ecosystemId})
    },

    getDiligenceFieldsForFilter(id) {
        return axios.get(`${RESOURCE_NAME}/get-diligence-fields-for-filter?id=${id}`)
    },

    join(id) {
        return axios.post(`${RESOURCE_NAME}/join?id=${id}`)
    },

    leave(id) {
        return axios.post(`${RESOURCE_NAME}/leave?id=${id}`)
    },
}